import {
  cloneListOfCloneable, DataModelBuilder, isSameList, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { TicketTemplate } from '../../models/serializable/ticket-template';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';
import { VersionRange } from '../../models/core/version-range.js';

export class TicketTemplateComponent extends Component {
  static readonly TYPE_ID: string = '28485ac7cad4438f849aa9085bfc8a6a';
  static readonly SCHEMA_VERSION: number = 2;

  constructor(
    public readonly tickets: TicketTemplate[],
    public readonly showSellingCountdown: boolean,
  ) {
    super();
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return TicketTemplateComponent.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.between(1, TicketTemplateComponent.SCHEMA_VERSION);
  }

  static empty(): TicketTemplateComponent {
    return new TicketTemplateComponent([], false);
  }

  static fromMap(context: SerializationContext, map: SerializedData): TicketTemplateComponent {
    return new TicketTemplateComponent(
        MapUtils.getList(map, 'tickets', (data) => context.fromData<TicketTemplate>(data as SerializedData)),
        MapUtils.getBoolean(map, 'showSellingCountdown'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'tickets': this.tickets.map((template) => context.toData(template)),
      'showSellingCountdown': this.showSellingCountdown,
    };
  }

  clone(): this {
    return new TicketTemplateComponent(
        cloneListOfCloneable(this.tickets),
        this.showSellingCountdown,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.tickets, this.tickets) &&
      other.showSellingCountdown === this.showSellingCountdown;
  }
}

export class TicketTemplateComponentBuilder extends DataModelBuilder<TicketTemplateComponent> {
  build(context: SerializationContext, map: SerializedData): TicketTemplateComponent {
    return TicketTemplateComponent.fromMap(context, map);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);

    if(versionRange.contains(TicketTemplateComponent.SCHEMA_VERSION)) {
      return map;
    }

    if(versionRange.isGreaterThan(TicketTemplateComponent.SCHEMA_VERSION)) {
      return null; // This data comes from the FUTURE. We have no idea how to migrate it.
    }

    let version = versionRange.to;

    if(version < 2) {
      map['showSellingCountdown'] ??= false;
      version = 2;
    }

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
